import { render, staticRenderFns } from "./FinalExport.vue?vue&type=template&id=54c9a5e0&scoped=true"
import script from "./FinalExport.vue?vue&type=script&lang=ts"
export * from "./FinalExport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9a5e0",
  null
  
)

export default component.exports